import { useEffect, useState } from "react";
import styled from "styled-components";
import CreateCategoryForm from "../../components/CreateCategory/CreateCategoryForm";
import { ValidateCategoryData } from "./ValidateCategoryData";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  allEqual,
  getFomattedCategoryDataFromId,
  getFomattedPostCategoryData,
  getFormattedParks,
} from "../../helper";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import {
  fetchAllProducts,
  getCategoryDataFromId,
  postCreateCategoryData,
  putUpdatedCategoryData,
} from "../../services/productService";
import { useLoadContext } from "../../contexts/LoadContext";
import { getSettings } from "../../services/settingsService";
import { uploadEventImage } from "../../services/eventsService";
import { toast } from "react-toastify";
import { ToastMessage } from "../../components/ToastMessage";
import { ActiveDeactive, InfoWrapper, StyledStatus } from "../AddOutlet";
import InfoAndText from "../../components/ManageOutlet/InfoAndText";
import Toggle from "../../components/Toggle";

export interface CategoryDataType {
  categoryName: string;
  status: string;
  categoryInformation: string;
  cardColorCode: string;
  productId: string;
  isDependent: boolean;
  dependentProduct: string;
  aquaAvailableUnit: string;
  aquaGroup: string;
  imageUrl: any;
  isTaxEnabled: boolean;
  taxClassification: string;
}

const CreateCategory = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [category, setCategory] = useState([]);
  const [durations, setDurations] = useState([]);
  const [durationErrorDataError, setDurationDataError] = useState([]);
  let outletId = searchParams.get("outletId");
  let product = searchParams.get("product");
  const [uploadedImage, setUploadedImage] = useState();
  const [isSpecialProduct, setIfSpecialProduct] = useState(false);
  const [taxClassificationList, setTaxClassificationList] = useState([]);

  const navigate = useNavigate();
  const { setLoader } = useLoadContext();
  const [categoryData, setCategoryData] = useState({
    categoryName: "",
    status: "",
    categoryInformation: "",
    cardColorCode: "",
    productId: "",
    dependentProduct: "",
    isDependent: false,
    aquaAvailableUnit: "",
    aquaGroup: "",
    imageUrl: [],
    isTaxEnabled: false,
    taxClassification: "",
  });
  const [pricingData, setPricingData] = useState({
    type: "",
    price: "",
  });
  const [price, setPrice] = useState({
    mon: "",
    tue: "",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
  });
  const [priceDataError, setPriceDataError] = useState({
    mon: "",
    tue: "",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
  });
  const [categoryDataError, setCategoryDataError] = useState({
    categoryName: "",
    status: "",
    categoryInformation: "",
    cardColorCode: "",
    productId: "",
    type: "",
    price: "",
    dependentProduct: "",
    logoUrl: "",
    aquaAvailableUnit: "",
    aquaGroup: "",
    imageUrl: "",
    taxClassification: "",
  });
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!id) {
      if (!outletId || !product) {
        navigate("/admin/manage-parks");
      }
    }
  }, [outletId, product, id]);

  useEffect(() => {
    fetchProducts(product, outletId);
  }, [product, outletId]);

  useEffect(() => {
    if (id) {
      fetchCategoryDataFromId();
      fetchSettings(id);
    } else {
      fetchSettings(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchSettings = async (id: any) => {
    let settings = await getSettings("cms");
    let classificationObj = settings?.data?.data?.tax_classification.map(
      (tc: any) => {
        return {
          label: tc.value,
          value: tc.key,
        };
      }
    );
    classificationObj.unshift({
      value: "",
      label: "Select Tax Classification",
    });
    setTaxClassificationList(classificationObj);

    if (!id) {
      let categoryObj = settings?.data?.data?.aqua?.category.map(
        (category: string) => {
          return {
            label: category,
            value: category,
          };
        }
      );
      categoryObj.unshift({
        value: "",
        label: "Select Category",
      });
      let durationObj = settings?.data?.data?.aqua?.duration.map(
        (duration: string) => {
          return {
            label: duration,
            value: duration,
            price: 0,
          };
        }
      );
      setCategory(categoryObj);
      setDurations(durationObj);
    }
  };

  const fetchProducts = async (category: any, outletId: any) => {
    let res = await fetchAllProducts(category, outletId);
    setProducts(getFormattedParks(res?.data?.data));
  };

  const uploadImage = (event: any) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.files[0].size > 2048756
        //  ||
        // img.width > 672 ||
        // img.height > 378
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else {
        try {
          let { data } = await uploadEventImage(event.target.files[0]);
          setUploadedImage(data.files[0]);
          let formData = { ...categoryData };
          let formError = { ...categoryDataError };
          formData["imageUrl"] = [];
          //@ts-ignore
          formData["imageUrl"].push(data.files[0]);
          //@ts-ignore
          formError["imageUrl"] = "";
          setCategoryData(formData);
          setCategoryDataError(formError);
        } catch (error: any) {
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        }
      }
    };
  };

  const handleChange = (event: any) => {
    let formData = { ...categoryData };
    let formError = { ...categoryDataError };

    if (event.target.name === "imageUrl") {
      uploadImage(event);
    } else {
      if (event.target.name === "isDependent") {
        formData.dependentProduct = "";
        formError.dependentProduct = "";
      }
      if (event.target.name === "isTaxEnabled") {
        formData.taxClassification = "";
        formError.taxClassification = "";
      }
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
      setCategoryData(formData);
      setCategoryDataError(formError);
    }
  };

  const handlePricingChange = (event: any) => {
    let formData = { ...pricingData };
    let formError = { ...categoryDataError };
    //@ts-ignore
    formData[event.target.name] = event.target.value;
    //@ts-ignore
    formError[event.target.name] = "";

    if (event.target.name === "type") {
      if (event.target.value === "multi") {
        formData.price = "";
        formError.price = "";
      }
      if (event.target.value === "single") {
        setPrice({
          mon: "",
          tue: "",
          wed: "",
          thu: "",
          fri: "",
          sat: "",
          sun: "",
        });
        setPriceDataError({
          mon: "",
          tue: "",
          wed: "",
          thu: "",
          fri: "",
          sat: "",
          sun: "",
        });
      }
    }

    setPricingData(formData);
    setCategoryDataError(formError);
  };

  const handlePriceChange = (event: any) => {
    let priceData = { ...price };
    let priceError = { ...priceDataError };
    //@ts-ignore
    priceData[event.target.name] = event.target.value;
    //@ts-ignore
    priceError[event.target.name] = "";
    setPrice(priceData);
    setPriceDataError(priceError);
  };

  const removeImage = (e: any) => {
    let formData = { ...categoryData };
    let formError = { ...categoryDataError };
    //@ts-ignore
    formData.imageUrl = formData.imageUrl.filter((each) => each.viewUrl !== e);
    setCategoryData(formData);
    setCategoryDataError(formError);
    setUploadedImage(undefined);
  };

  const handleSubmit = () => {
    console.log(categoryData);

    if (
      !ValidateCategoryData(
        categoryData,
        price,
        pricingData,
        setCategoryDataError,
        setPriceDataError,
        durations,
        setDurationDataError,
        product
      )
    ) {
      if (id) {
        updateCategoryData({
          ...getFomattedPostCategoryData(
            categoryData,
            price,
            product,
            pricingData,
            durations,
            isSpecialProduct
          ),
          outletId,
        });
      } else {
        postCategoryData({
          ...getFomattedPostCategoryData(
            categoryData,
            price,
            product,
            pricingData,
            durations,
            isSpecialProduct
          ),
          outletId,
        });
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const fetchCategoryDataFromId = async () => {
    setLoader(true);
    try {
      let response = await getCategoryDataFromId(id);

      if (product === "aqua_zone") {
        let settings = await getSettings("cms");
        let categoryObj = settings?.data?.data?.aqua?.category.map(
          (category: string) => {
            return {
              label: category,
              value: category,
            };
          }
        );
        categoryObj.unshift({
          value: "",
          label: "Select Category",
        });
        let durationObj = settings?.data?.data?.aqua?.duration.map(
          (duration: string) => {
            return {
              label: duration,
              value: duration,
              price:
                response?.data?.data?.aquaPrice?.filter(
                  (price: any) => price.duration === duration
                )[0]?.price || "",
            };
          }
        );
        setCategory(categoryObj);
        setDurations(durationObj);
      }

      if (response.status === 200) {
        setLoader(false);
        setCategoryData(getFomattedCategoryDataFromId(response.data.data));
        setIfSpecialProduct(response?.data?.data?.isSpecialProduct);
        let prices = Object.values(response?.data?.data?.price || {});
        let isAllEqual = allEqual(prices);
        if (isAllEqual) {
          setPrice({
            mon: "",
            tue: "",
            wed: "",
            thu: "",
            fri: "",
            sat: "",
            sun: "",
          });
          setPricingData({
            type: "single",
            price: response?.data?.data?.price?.mon || 0,
          });
        } else {
          setPrice(response?.data?.data?.price);
          setPricingData({
            type: "multi",
            price: "",
          });
        }
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };
  const postCategoryData = async (data: any) => {
    setLoader(true);
    try {
      let response = await postCreateCategoryData(data);
      if (response.status === 201) {
        setLoader(false);
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };
  const updateCategoryData = async (data: any) => {
    setLoader(true);
    try {
      let response = await putUpdatedCategoryData(data, id);
      if (response.status === 200) {
        setLoader(false);
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleAddAnotherDuration = () => {
    let newDuration = { label: "", price: "", value: "" };
    let durationsSpreaded = [...durations];
    // @ts-ignore
    durationsSpreaded.push(newDuration);
    setDurations(durationsSpreaded);
  };

  const handleAquaPriceChange = (e: any, idx: any) => {
    let durationArray = [...durations];
    if (e.target.name === "duration") {
      // @ts-ignore
      durationArray[idx]["label"] = e.target.value;
      // @ts-ignore
      durationArray[idx]["value"] = e.target.value;
    } else {
      // @ts-ignore
      durationArray[idx]["price"] = e.target.value;
    }
    setDurations([...durationArray]);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Header>{id ? "Edit Product" : "Create Product"}</Header>
        <InfoWrapper>
          <InfoAndText text="(This toggle is to switch between special and non special products)" />
          <StyledStatus>
            Is A Special Product:
            <Toggle
              uniqueName={"isSpecialProduct"}
              isChecked={isSpecialProduct}
              onChange={() => setIfSpecialProduct(!isSpecialProduct)}
            />
            <ActiveDeactive status={isSpecialProduct}>
              {isSpecialProduct ? "Yes" : "No"}
            </ActiveDeactive>
          </StyledStatus>
        </InfoWrapper>
      </div>
      <CreateCategoryForm
        data={categoryData}
        priceData={price}
        pricingData={pricingData}
        onChange={handleChange}
        onPriceChange={handlePriceChange}
        onPricingChange={handlePricingChange}
        priceError={priceDataError}
        error={categoryDataError}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        products={products}
        product={product}
        category={category}
        onRemove={removeImage}
        uploadedImage={uploadedImage}
        durations={durations}
        onAddAnotherDuration={handleAddAnotherDuration}
        onAquaPriceChange={handleAquaPriceChange}
        taxClassificationList={taxClassificationList}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
      {isSuccessModal && (
        <ErrorSuccessModal
          variant="success"
          heading={"Product saved successfully."}
          buttonLabel="Ok"
          setOpenOrClose={setIsSuccessModal}
          onSubmit={() => {
            setIsSuccessModal(false);
            navigate(-1);
          }}
        />
      )}
    </>
  );
};

export default CreateCategory;

export const Header = styled.div`
  font-size: 1.25rem;
  padding-bottom: 2rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
